import classnames from 'classnames'
import { Input } from '../Input/index'
import { List } from '../List/index'
import styles from './index.module.css'

const Clear = ({ handleClickClearButton }) => {
    return (
        <button type="button" className={styles.close} onClick={handleClickClearButton}>
            <span className="Appkit4-icon icon-close-outline"></span>
        </button>
    )
}

export const View = ({
    itemKey,
    isActive,
    width,
    selectRef,
    onClick,
    handleKeyDownInput,
    inputProps,
    handleClickClearButton,
    isSearch,
    isClear,
    searchInputProps,
    data,
    onItemClick,
    selectedValue,
    className,
    hasError,
    ...props
}) => {
    const activeClass = isActive ? styles.active : ''
    const errorClass = hasError ? styles.error : ''

    return (
        <div className={classnames(styles.default, activeClass, errorClass, className)} ref={selectRef} {...props}>
            <div className={styles.select_input}>
                <Input width={width} readOnly={true} onClick={onClick} onKeyDown={handleKeyDownInput} {...inputProps} />
                {isClear && inputProps.value && <Clear handleClickClearButton={handleClickClearButton} />}
                <span className={`Appkit4-icon icon-down-chevron-outline ${styles.arrow}`}></span>
            </div>
            <div style={{ width }} className={classnames(styles.select)}>
                {isSearch && <Input width={width - 10} className={styles.search_input} {...searchInputProps} />}
                <List
                    className={styles.select_option}
                    data={data}
                    onItemClick={onItemClick}
                    itemKey={itemKey}
                    selectedValue={selectedValue}
                />
                {isSearch && !data.length && (
                    <span className={styles.result_text}>No matches for &quot;{searchInputProps.value}&quot;</span>
                )}
            </div>
        </div>
    )
}
